import { Button, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import xIcon from "../../images/xIcon.png";
import "./index.css";

const CheckBooking = () => {
  const [bookingId, setBookingId] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [disabledButton, setDisabledButton] = useState(true);
  const navigate = useNavigate();
  const handleOnClick = useCallback(
    () =>
      navigate(`/BookingSummary/${emailAddress}/${bookingId}`, {
        replace: true,
      }),
    [navigate, bookingId, emailAddress]
  );

  useEffect(() => {
    if (bookingId && emailAddress) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [bookingId, emailAddress]);

  return (
    <div className=" flex flex-col justify-center items-center ">
      <div className="flex flex-col bg-white py-6 px-6 md:rounded-xl drop-shadow-xl">
        <Link to={"/"} onClick={() => localStorage.clear()}>
          <div className="flex justify-end">
            <img src={xIcon} className="w-[12px]"></img>
          </div>
        </Link>
        <div className="flex flex-col space-y-5 p-5">
          <div className="flex flex-col items-center">
            <div className="font-bold text-xl uppercase">Booking Status</div>
            <div className="text-justify">
              Input your email and booking id to check booking status here.
            </div>
          </div>
          <TextField
            id="email"
            name="email"
            required
            label="Email"
            variant="outlined"
            onChange={(e) => {
              setEmailAddress(e.target.value);
            }}
            style={{
              borderRadius: "20px",
            }}
          />
          <TextField
            id="bookingId"
            name="bookingId"
            label="Booking ID"
            required
            variant="outlined"
            onChange={(e) => {
              setBookingId(e.target.value);
            }}
            style={{
              borderRadius: "20px",
            }}
          />
          <div className="flex justify-center">
            <Button
              id="submit"
              onClick={() => handleOnClick()}
              variant="contained"
              disabled={disabledButton}
              style={{
                fontWeight: "bold",
                borderRadius: "10px",
                width: "50%",
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckBooking;
